import { __count__, __add__, __get__, __modify__ } from './db';

function findAndModify(params: FindAndModifyParams): Promise<void> {
    return new Promise<void>(async (resolve: () => void, reject: () => void) => {
        let dataList: Array<FreeObjMap> = await __get__(params.tableName, params.query);

        if (!dataList.length) {
            await __add__(params.tableName, params.updateData);
        }
        else {
            await __modify__(params);
        }

        resolve();
    });
}

export {
    findAndModify
};
